import { j as s, c as f } from "./utils-BdNIfrGQ.js";
import { F as d } from "./Flex-BA9xHq_p.js";
import { n as p } from "./normalize-spacing-DY0KSpr_.js";
import { n as c } from "./normalize-gap-CHOQjV8I.js";
import { c as l } from "./index-Di82Y7n3.js";
const m = l("", {
  variants: {
    branding: {
      default: "bg-white text-dark",
      results: "bg-primary text-primary-foreground",
      branded: "bg-secondary text-secondary-foreground",
      transparent: "",
      "primary-gradient": "bg-gradient-to-b from-primary to-transparent text-primary-foreground py-6",
      "secondary-gradient": "bg-gradient-to-b from-secondary to-transparent text-secondary-foreground py-6"
    },
    orientation: {
      responsive: "flex-col sm:flex-row",
      horizontal: "flex-row flex-wrap",
      vertical: "flex-col"
    }
  },
  defaultVariants: {
    branding: "transparent",
    orientation: "horizontal"
  }
}), j = ({
  branding: r,
  orientation: t,
  spacing: a,
  gap: o,
  leftSlot: n,
  rightSlot: e,
  ...i
}) => /* @__PURE__ */ s.jsxs(
  d,
  {
    className: f(
      m({ branding: r, orientation: t }),
      p(a),
      c(o),
      `justify-center ${r === null ? "bg-[#1c75bd] text-[#ffffff]" : ""}`
    ),
    ...i,
    children: [
      n,
      e
    ]
  }
);
export {
  j as S
};
